import gql from 'graphql-tag';
import { get } from 'lodash';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query ProjectScoringMethod($projectId: Int!, $generationTool: GenerationToolEnum!) {
    project(id: $projectId) {
      id

      lastUsedScoringMethod(generationTool: $generationTool) {
        id
        type
      }
    }
  }
`;

export const queryProjectScoringMethod = async ({ projectId, generationTool }) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
      generationTool,
    },
  });

  const data = getSingleProp(result.data);
  return get(data, 'lastUsedScoringMethod');
};
